import React from 'react';

const Unauthorized = () => {
    return (
        <div className="OuterMostDiv" data-testid='OuterMostDiv'>
            <div data-testid='InnerDiv' style={{ overflow: "hidden !important", marginLeft: "10%" , width: '70%'}}>
                <div className={'alert alert-danger text-center'}>
                    <b>Unauthorized: You do not have permissions to view/access this resource.</b>
                </div>
            </div>
        </div>
    );
}

export default Unauthorized;